<div class="layout-column edit-entry-panel" appBringozIdGenerator="editTimecardEntryPanel">

  <div class="layout-row layout-align-start-center edit-entry-panel-header">
    <span class="flex">
      <span class="font-weight-600">{{ data.stopName }}</span>
      <span class="edit-entry-panel-field">{{ fieldLabel | translate }}</span>
    </span>
    <bz-button variant="tertiary" size="fit" appBringozIdGenerator="closeBtn"
               [ariaLabel]="'Close' | translate" (clicked)="onCancel()">
      <bz-icon size="sm" [icon]="icons.close"></bz-icon>
    </bz-button>
  </div>

  <div class="layout-column timecard-dialog-body edit-entry-panel-body">
    @switch (editMode) {
      @case ('distance') {
        <bz-form-field [label]="('Distance' | translate) + ' (' + (data.siteDistanceUnit | translate) + ')'"
                       [error]="(validationError() || '') | translate">
          <bz-input type="number"
                    size="sm"
                    placeholder="0"
                    appBringozIdGenerator="distanceInput"
                    [value]="distance()"
                    [invalid]="!!validationError()"
                    (valueChange)="onDistanceChange($event)">
          </bz-input>
        </bz-form-field>
      }
      @case ('serviceTime') {
        <div class="timecard-dialog-row">
          <bz-form-field class="flex" [label]="'Hours' | translate">
            <bz-input type="number"
                      size="sm"
                      placeholder="0"
                      appBringozIdGenerator="hoursInput"
                      [value]="hours()"
                      (valueChange)="hours.set($event)">
            </bz-input>
          </bz-form-field>
          <bz-form-field class="flex" [label]="'Minutes' | translate">
            <bz-input type="number"
                      size="sm"
                      placeholder="0"
                      appBringozIdGenerator="minutesInput"
                      [value]="minutes()"
                      (valueChange)="onMinutesChange($event)">
            </bz-input>
          </bz-form-field>
        </div>

        @if (data.plannedServiceTime || data.passiveTrackingServiceTime) {
          <div class="timecard-dialog-info">
            @if (data.plannedServiceTime) {
              <span>{{ 'Planned' | translate }}: {{ data.plannedServiceTime | bringozTimeHHMM }}</span>
            }
            @if (data.plannedServiceTime && data.passiveTrackingServiceTime) {
              <bz-divider orientation="vertical"></bz-divider>
            }
            @if (data.passiveTrackingServiceTime) {
              <span>{{ 'Passive Tracking' | translate }}: {{ data.passiveTrackingServiceTime | bringozTimeHHMM }}</span>
            }
          </div>
        }
      }
      @default {
        <bz-form-field [error]="(validationError() || '') | translate">
          <app-timecard-date-time-field [timeStamp]="selectedTime()"
                                        [minTime]="data.clockInTime"
                                        [maxTime]="data.clockOutTime"
                                        (timeChange)="onTimeSelect($event)">
          </app-timecard-date-time-field>
        </bz-form-field>
      }
    }
  </div>

  <div class="layout-row layout-align-space-between-center edit-entry-panel-actions">
    <bz-button variant="tertiary" appBringozIdGenerator="cancelBtn" (clicked)="onCancel()">
      {{ 'Cancel' | translate }}
    </bz-button>
    <bz-button tone="secondary" appBringozIdGenerator="submitBtn" [disabled]="!!validationError()" (clicked)="onSubmit()">
      {{ 'Submit' | translate }}
    </bz-button>
  </div>

</div>
